import React from 'react';
import { reduxForm, Field, FormSection } from 'redux-form';
import InputField from '../InputField';
import FormError from '../FormError';
import { formatSaveStatus } from 'helpers/formatters';

let PortForm = ({ handleSubmit, error, saveStatus, initialValues }) => (
  <div>
    <form onSubmit={handleSubmit}>
      <Field component={InputField} name="mdn" label="MDN" />
      {initialValues && initialValues.carrier !== undefined && (
        <Field component={InputField} name="carrier" label="Carrier" />
      )}
      <FormSection name="port_details">
        <Field component={InputField} name="account" label="Account" />
        <Field component={InputField} name="pin" label="Pin" />
        <Field
          component={InputField}
          name="authorized_by"
          label="Authorized By"
        />
        <Field component={InputField} name="first_name" label="First Name" />
        <Field component={InputField} name="last_name" label="Last Name" />
        <Field component={InputField} name="street" label="Street" />
        <Field component={InputField} name="city" label="City" />
        <Field component={InputField} name="state" label="State" />
        <Field component={InputField} name="zip_code" label="Zip Code" />
      </FormSection>
      {initialValues && initialValues.remark !== undefined && (
        <Field component={InputField} name="remark" label="Remark" />
      )}
      {error && <FormError error={error} />}
      <br />
      <button className="btn btn-default" disabled={saveStatus === 'PENDING'}>
        Save Port
      </button>
      <span className="submit-status">{formatSaveStatus(saveStatus)}</span>
    </form>
  </div>
);

PortForm = reduxForm({
  form: 'port',
})(PortForm);

export default PortForm;
